import {
  AddressBookDto,
  AddressBookScreenPropertiesModel,
  SaveAddressRequest,
} from '@/services/platform/api/model';
import { ProfileAddressesBook } from '@/components/shared/profile/adresses/book';

interface ProfileAccountAddressBookProps {
  addresses: AddressBookDto[] | undefined;
  pageProperties: AddressBookScreenPropertiesModel | undefined;
  loading?: boolean;
  onSave: (data: SaveAddressRequest) => Promise<void>;
  onUpdate: (id: string, data: SaveAddressRequest) => Promise<void>;
  onDelete: (id: string) => Promise<void>;
}

export function ProfileAccountAddressBook({
  addresses,
  pageProperties,
  loading = false,
  onSave,
  onUpdate,
  onDelete,
}: ProfileAccountAddressBookProps) {
  return (
    <ProfileAddressesBook
      addresses={addresses}
      pageProperties={pageProperties}
      loading={loading}
      onSave={onSave}
      onUpdate={onUpdate}
      onDelete={onDelete}
    />
  );
}
